import {TFunction} from 'i18next';
import {forEach, isEmpty, isInteger, set} from 'lodash';

import {ValidationCode} from 'enums';
import {SpecialDayWorkingHoursItem, WorkingHoursInterval} from 'types';
import {apiUtils} from 'utils';

const MAX_YEAR = new Date().getFullYear() + 10;

const buildErrorWithCode = (code: ValidationCode, t: TFunction) => apiUtils.getErrorMessageByCode(t, {code});

const validateInterval = ({from, to}: WorkingHoursInterval = {from: null, to: null}, t: TFunction): {isValid: boolean, error?: any} => {
    if (!isInteger(from?.hours) && !isInteger(to?.hours)) {
        return {isValid: false};
    }

    if (!isInteger(from?.hours) || !isInteger(to?.hours)) {
        return {
            isValid: false,
            error: {
                ...(!isInteger(from?.hours) && {from: buildErrorWithCode(ValidationCode.Invalid, t)}),
                ...(!isInteger(to?.hours) && {to: buildErrorWithCode(ValidationCode.Invalid, t)})
            }
        };
    }
    const hoursInvalid = from.hours > to.hours;
    const minutesInvalid = from.hours === to.hours && from.minutes >= to.minutes;
    if (hoursInvalid || minutesInvalid) {
        return {
            isValid: false,
            error: {
                from: buildErrorWithCode(ValidationCode.Invalid, t),
                to: buildErrorWithCode(ValidationCode.Invalid, t)
            }
        };
    }

    return {isValid: true};
};

const validateSpecialDay = (specialHour: SpecialDayWorkingHoursItem, t: TFunction): {isValid: boolean, error?: any} => {
    const specialDayError = {};
    if (specialHour.year > MAX_YEAR) {
        set(specialDayError, 'year', buildErrorWithCode(ValidationCode.MaxDate, t));
    }

    forEach(specialHour?.intervals, (interval, intervalIndex) => {
        const {isValid, error} = validateInterval(interval, t);
        if (!isValid) {
            set(specialDayError, `intervals[${intervalIndex}]`, error);
        }
    });

    return {
        isValid: isEmpty(specialDayError),
        error: specialDayError
    };
};

export const workingHoursUtils = {
    validateInterval,
    validateSpecialDay
};